<template>
  <h2 class="lead-title-2">
    <span class="main-title" v-if="mainTitle">{{ mainTitle }}</span>
    <span class="sub-title" v-if="subTitle">{{ subTitle }}</span>
  </h2>
</template>

<script>
export default {
  name: 'LeadTitle2',
  props: {
    mainTitle: String,
    subTitle: String,
  }

}
</script>

<style lang="scss">
@import "LeadTitle2";
</style>
